import { render, staticRenderFns } from "./StepLastPage.vue?vue&type=template&id=4265a977&"
import script from "./StepLastPage.vue?vue&type=script&lang=js&"
export * from "./StepLastPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports